export default "__VITE_ASSET__qhc3XagG__"